import { MdOutlineOpenInNew, MdOutlinePreview } from "react-icons/md";
import CodeView from "./Code/CodeView";
import Preview from "./View/Preview";
import { TbCode, TbDownload } from "react-icons/tb";
import { useParams } from "react-router-dom";
import { useRef, useState } from "react";
import Spinner from "../../Components/Spinner";

const MainCodespaceBody = ({ isSidebarClosed, codebase, setCodebase, view, setOpenView, getCodebase, fetchFileContent, activeTab, setActiveTab, selectedFilePath, setSelectedFilePath, context, hasPreview, previewUrl, reloadPrev }) => {
    const user_id = sessionStorage.getItem("user_id");
    const { project_id } = useParams();
    const [loadingFetch, setLoadingFetch] = useState(false)
    const [loadingDownload, setLoadingDownload] = useState(false)
    const [copied, setCopied] = useState(false)
    const headerRef = useRef(null);

    const downloadSourceCode = async () => {
        setLoadingDownload(true)
        try {
            const response = await fetch("https://aiservice.erioon.com/download_source_code", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ user_id, project_id }),
            });

            if (response.ok) {
                const blob = await response.blob();
                console.log(blob)
                const url = window.URL.createObjectURL(blob);

                const a = document.createElement("a");
                a.href = url;
                a.download = `${project_id}.zip`;
                document.body.appendChild(a);
                a.click();
                a.remove();

                window.URL.revokeObjectURL(url);
            } else {
                setLoadingDownload(false)
                console.error("Failed to download project", response.status);
            }
        } catch (err) {
            setLoadingDownload(false)
            console.error("Error Downloading code:", err);
        } finally {
            setLoadingDownload(false)
        }
    };

    const CopyLink = (link) => {
        navigator.clipboard.writeText(link)
            .then(() => {
                setCopied(true)
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
            });

        setTimeout(() => {
            setCopied(false)
        }, 2000);
    };

    return (
        <div
            ref={headerRef}
            className={`main_codespaces_cont_main_body ${isSidebarClosed ? "" : "main_codespaces_cont_main_body_closed"}`}
        >
            <div className="main_codespaces_cont_main_body_navbar">
                <div className="main_codespaces_cont_main_body_navbar_cont">
                    <div className="main_codespaces_cont_main_body_btn_cont">
                        <div onClick={() => setOpenView("preview")} className={`action_nav_codebase_btn ${view == "preview" ? "selected_action_nav_codebase_btn" : ""}`}><MdOutlinePreview /></div>
                        <div onClick={() => setOpenView("code")} className={`action_nav_codebase_btn ${view == "code" ? "selected_action_nav_codebase_btn" : ""}`}><TbCode /></div>
                    </div>
                </div>
                <div className="main_codespaces_cont_main_body_navbar_cont">
                    <div className="link_bar_preview">
                        {hasPreview ? (
                            <div className="link_bar_preview_inner" >
                                <i className={`fa-solid fa-rotate ${loadingFetch ? "loading_notification" : ""}`} ></i>
                                <p onClick={() => CopyLink(previewUrl)}>
                                    {copied ? (
                                        <i className="fa-solid fa-check fade-in"></i>
                                    ) : (
                                        <span className="fade-in">
                                            {previewUrl}
                                        </span>
                                    )}
                                </p>
                                <i onClick={() => window.open(previewUrl, "_blank")}><MdOutlineOpenInNew /></i>
                            </div>
                        ) : (
                            <div className="link_bar_preview_inner" >
                                <i className={`fa-solid fa-rotate ${loadingFetch ? "loading_notification" : ""}`} ></i>
                                <p className="fade-in">https://www.erioon.com</p>
                                <i onClick={() => window.open(previewUrl, "_blank")}><MdOutlineOpenInNew /></i>
                            </div>
                        )}
                    </div>
                </div>
                <div className="main_codespaces_cont_main_body_navbar_cont">
                    { !loadingDownload ? 
                        (
                            <button className="open_back_btn" onClick={downloadSourceCode}>Source code <TbDownload /></button>
                        ) : (
                            <button className="open_back_btn">
                                <Spinner loading={loadingDownload} />
                            </button>
                        )
                    }
                </div>
            </div>

            {context == "serverless" ? (
                view == "code" ? (
                    <CodeView codebase={codebase} setCodebase={setCodebase} getCodebase={getCodebase} fetchFileContent={fetchFileContent} activeTab={activeTab} setActiveTab={setActiveTab} selectedFilePath={selectedFilePath} setSelectedFilePath={setSelectedFilePath} context={context}
                    />
                ) : (
                    <Preview hasPreview={hasPreview} previewUrl={previewUrl} reloadPrev={reloadPrev}/>
                )
            ) : (
                <></>
            )}
        </div>


    )



};

export default MainCodespaceBody;
